import React from 'react';
import PropTypes from 'prop-types';

import DynamicLayout from '../../components/DynamicLayout';

const Component = props => <DynamicLayout pageId={props.pageId} analyticsContext={props.analyticsContext}/>;

Component.propTypes = {
  pageId: PropTypes.string.isRequired,
  analyticsContext: PropTypes.string.isRequired
};

export default Component;



// WEBPACK FOOTER //
// ./src/client/js/view/routes/DynamicLayout/DynamicLayout.js